// import Main from './Main'
import Variaveis from './components/Variaveis'

export default [
  {path: 'variaveis', component: Variaveis, name: 'configuracoes.variaveis'}
]
